import React, { Fragment, useEffect } from "react";
import { Box, IconButton, Switch, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import i18next from "i18next";
import SaitButton from "../atomic/SaitButton";
import SaitNumberField from "../atomic/SaitNumberField";
import SaitDialog from "../atomic/SaitDialog";

export function GridToolbarAutoreloadButton(props) {
	return props.toolbarIcons ? (
		<IconButton loading={props.isFiltering} onClick={() => props.setOpenDialogAutoreload(true)}>
			<RefreshIcon color={props.autoreloadOn ? "success" : "primary"} />
		</IconButton>
	) : (
		<SaitButton
			text={i18next.t("autoreload")}
			loading={props.isFiltering}
			onClick={() => props.setOpenDialogAutoreload(true)}
			startIcon={<RefreshIcon />}
			variant="text"
			color={props.autoreloadOn ? "success" : "primary"}
		/>
	);
}

export function GridToolbarAutoreloadDialog(props) {
	const minSeconds = props.minAutoreloadSeconds || 10;
	const [autoreloadSeconds, setAutoreloadSeconds] = React.useState(minSeconds);
	const autoreloadInterval = React.useRef(null);
	const setAutoreloadInterval = (value) => {
		autoreloadInterval.current = value;
	};

	useEffect(() => {
		// Funzione di cleanup che viene eseguita quando il componente si smonta
		return () => {
			clearInterval(autoreloadInterval.current);
		};
	}, []);

	useEffect(() => {
		if (props.autoreloadOn) {
			const intervalId = setInterval(() => {
				const element = props.gridRef.current;

				// Controlla se l'elemento è visibile
				if (element && isElementVisible(element)) {
					props.handleFireFilter();
				}
			}, autoreloadSeconds * 1000);

			setAutoreloadInterval(intervalId);
		} else {
			clearInterval(autoreloadInterval.current);
			setAutoreloadInterval(null);
		}
	}, [props.autoreloadOn]);

	function isElementVisible(el) {
		// Controlla se è nel viewport e non nascosto
		const rect = el.getBoundingClientRect();
		const style = window.getComputedStyle(el);

		const basicVisible = style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0" && rect.width > 0 && rect.height > 0;

		if (!basicVisible) return false;

		// Controlla se l'elemento è coperto da altri elementi (es. modale)
		const centerX = rect.left + rect.width / 2;
		const centerY = rect.top + rect.height / 2;

		// Ottieni l'elemento più in alto in quella posizione
		const topElement = document.elementFromPoint(centerX, centerY);

		// Verifica se l'elemento cliccabile è la griglia stessa o un suo discendente
		const isNotCovered = topElement && (el === topElement || el.contains(topElement));

		return isNotCovered;
	}

	useEffect(() => {
		clearInterval(autoreloadInterval.current);
		setAutoreloadInterval(null);
		props.setAutoreloadOn(false);
	}, [autoreloadSeconds]);

	const checkAutoreloadSeconds = () => {
		const autoreloadSecondsNumber = Number(autoreloadSeconds);
		if (autoreloadSecondsNumber) {
			if (!isNaN(autoreloadSecondsNumber)) {
				if (autoreloadSecondsNumber >= minSeconds) {
					return true;
				}
			}
		}

		return false;
	};

	const activateAutoreload = (active) => {
		let activateAutoreload = false;
		if (active) {
			if (checkAutoreloadSeconds()) {
				activateAutoreload = true;
			}
		}
		props.setAutoreloadOn(activateAutoreload);
	};

	return (
		<SaitDialog
			open={props.openDialogAutoreload}
			title={i18next.t("autoreload")}
			width="xs"
			content={
				<Box
					sx={{
						p: 2,
						display: "flex",
						alignItems: "center",
						justifyContent: "center !important", // forza il centraggio
						gap: 3,
					}}
				>
					<SaitNumberField sx={{ width: "100px" }} value={autoreloadSeconds} onChange={(e) => setAutoreloadSeconds(e.target.value)} label={i18next.t("seconds")} />
					<Tooltip title={checkAutoreloadSeconds() ? "" : i18next.t("autoreload_error_message", { minSeconds: minSeconds })}>
						<span>
							<Switch checked={props.autoreloadOn} onChange={() => activateAutoreload(!props.autoreloadOn)} disabled={!checkAutoreloadSeconds()} />
						</span>
					</Tooltip>
				</Box>
			}
			actions={
				<Fragment>
					<SaitButton text={i18next.t("close")} color="error" onClick={() => props.setOpenDialogAutoreload(false)} />
					<Box sx={{ flexGrow: 1 }} />
				</Fragment>
			}
		/>
	);
}
